import numWord from '../../../utils/numWord';
import { useTranslation } from '../../../translations';

export const useToDaysLongHoursLongMinutesLong = () => {
  const { t } = useTranslation();

  return ({
    milliseconds,
    daysArray = [t('other.days.0.text'), t('other.days.1.text'), t('other.days.2.text')],
    hoursArray = [t('other.hours.0.text'), t('other.hours.1.text'), t('other.hours.2.text')],
    minutesArray = [t('other.minutes.0.text'), t('other.minutes.1.text'), t('other.minutes.2.text')],
    splitterBetweenParts = ' ',
    splitterInsidePart = '',
  }) => {
    const totalSeconds = Math.ceil(milliseconds / 1000);

    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.ceil((totalSeconds % 3600) / 60);

    if (days >= 1) {
      const finalHours = hours > 0 || minutes > 0 ? hours + 1 : hours;
      return `${days}${splitterInsidePart}${numWord(
        days,
        daysArray,
      )}${splitterBetweenParts}${finalHours}${splitterInsidePart}${numWord(finalHours, hoursArray)}`;
    }

    if (hours >= 1) {
      const finalMinutes = minutes > 0 ? minutes : 0;
      return `${hours}${splitterInsidePart}${numWord(
        hours,
        hoursArray,
      )}${splitterBetweenParts}${finalMinutes}${splitterInsidePart}${numWord(finalMinutes, minutesArray)}`;
    }

    return `${minutes} ${numWord(minutes, minutesArray)}`;
  };
};
